import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import networkInstance from "../../services/api";
import toastMessage from "../../toast";

const RefundModal = ({ isOpen, onClose }) => {
  // Validation Schema
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    transactionId: Yup.string().required("Previous Merchant ID is required"),
    refundAmount: Yup.number()
      .required("Refund amount is required")
      .positive("Amount must be positive")
      .typeError("Please enter a valid number"),
    // reason: Yup.string()
    //   .required("Reason is required")
    //   .min(10, "Reason must be at least 10 characters")
    //   .max(200, "Reason must not exceed 200 characters"),
  });

  // Initial Values
  const initialValues = {
    transactionId: "",
    refundAmount: "",
    // reason: "",
  };

  // Handle form submission
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { data } = await networkInstance.post(
        "admin/initiate_refund",
        values
      );
      if (data?.code === 200) {
        toastMessage("success", "driver added successfully");
      } else {
        toastMessage("error", "Something went wrong");
      }
      // Add your API call here
      // await processRefund(values);
      onClose();
    } catch (error) {
      toastMessage("error", "Error processing refund:");
    } finally {
      setSubmitting(false);
    }
  };

  // Formik hook
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <>
      {isOpen && (
        <div
          className="relative z-100"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div
            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            aria-hidden="true"
          ></div>
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <form onSubmit={formik.handleSubmit}>
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div
                        className="mx-auto flex w-[35px] h-[35px] absolute right-2.5 top-2.5 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10 cursor-pointer"
                        onClick={onClose}
                      >
                        <svg
                          className="h-6 w-6 text-red-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 6l12 12M6 18L18 6"
                          />
                        </svg>
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full">
                        <h3
                          className="text-base font-semibold leading-6 text-gray-900"
                          id="modal-title"
                        >
                          Refund Payment
                        </h3>

                        <div className="flex flex-col space-y-4 mt-4">
                          {/* Merchant ID */}
                          <div>
                            <label className="block text-sm font-bold text-gray-500 mb-1">
                              Previous Merchant ID*
                            </label>
                            <input
                              type="text"
                              name="transactionId"
                              className={`w-full px-3 py-2 border rounded-md ${
                                formik.touched.transactionId &&
                                formik.errors.transactionId
                                  ? "border-red-500"
                                  : "border-gray-300"
                              }`}
                              placeholder="Enter previous merchant ID"
                              {...formik.getFieldProps("transactionId")}
                            />
                            {formik.touched.transactionId &&
                              formik.errors.transactionId && (
                                <div className="text-red-500 text-sm mt-1">
                                  {formik.errors.transactionId}
                                </div>
                              )}
                          </div>

                          {/* Refund Amount */}
                          <div>
                            <label className="block text-sm font-bold text-gray-500 mb-1">
                              Refund Amount*
                            </label>
                            <input
                              type="number"
                              name="refundAmount"
                              className={`w-full px-3 py-2 border rounded-md ${
                                formik.touched.refundAmount &&
                                formik.errors.refundAmount
                                  ? "border-red-500"
                                  : "border-gray-300"
                              }`}
                              placeholder="Enter refund amount"
                              {...formik.getFieldProps("refundAmount")}
                            />
                            {formik.touched.refundAmount &&
                              formik.errors.refundAmount && (
                                <div className="text-red-500 text-sm mt-1">
                                  {formik.errors.refundAmount}
                                </div>
                              )}
                          </div>

                          {/* Reason */}
                          <div>
                            <label className="block text-sm font-bold text-gray-500 mb-1">
                              Reason for Refund*
                            </label>
                            <textarea
                              name="reason"
                              rows="3"
                              className={`w-full px-3 py-2 border rounded-md ${
                                formik.touched.reason && formik.errors.reason
                                  ? "border-red-500"
                                  : "border-gray-300"
                              }`}
                              placeholder="Enter reason for refund"
                              {...formik.getFieldProps("reason")}
                            />
                            {formik.touched.reason && formik.errors.reason && (
                              <div className="text-red-500 text-sm mt-1">
                                {formik.errors.reason}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      className=" inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500  sm:w-auto"
                      onClick={onClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="inline-flex w-full h-fit justify-center rounded-md bg-primaryGreen hover:bg-hoverGreen px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed mr-2"
                      disabled={!formik.isValid || formik.isSubmitting}
                    >
                      {formik.isSubmitting ? "Processing..." : "Process Refund"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RefundModal;
